<template>
  <Modal
    :id="'cmp-royalty-royalty_account-sidewindow-add_contract_form'"
    @cancelled="onCancel"
  >
    <template slot="header"
      >New Mechanical Contract For
      {{ selectedAccountDetails.royalty_account.royalty_account_name }}
    </template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <TextField
            :id="'contract_name'"
            class="m1"
            v-bind="textFieldConfig"
            type="text"
            :value="contract_mechanical_info.contract_name"
            required
            showValidationIcons
            @validated="onValidation"
            :placeholder="$t('contract_name')"
            @valuechanged="onTextFieldValueChange"
          />
          <Dropdown
            :showValidationIcons="false"
            :id="'territory_id'"
            class="m2"
            :options="territoriesTV"
            :selected="
              territoriesTV.find(
                (b) => b.value == contract_mechanical_info.territory_id
              )
            "
            :placeholder="$t('Territory Name')"
            deselect
            box
            @selectedChange="(b) => onDropdownChange('territory_id', b)"
          ></Dropdown>
          <v-layout row wrap>
            <v-flex xs12>
              <div class="label_box txtov">Physical</div>
              <div class="input_box_container">
                <div class="input_box_content">
                  <Dropdown
                    :showValidationIcons="false"
                    :id="'phy_mechanical_rate_id'"
                    class="m2"
                    :options="currentRatesTV"
                    :selected="
                      currentRatesTV.find(
                        (b) =>
                          b.value ==
                          contract_mechanical_info.phy_mechanical_rate_id
                      )
                    "
                    :placeholder="
                      $t('statutory Rate (leave Empty for Rate of Sale)')
                    "
                    deselect
                    box
                    @selectedChange="
                      (b) => onDropdownChange('phy_mechanical_rate_id', b)
                    "
                  ></Dropdown>
                </div>
                <div class="check_box_content">
                  <div class="dt-checkbox v2 s1">
                    <input
                      type="checkbox"
                      @click="(e) => onCheckboxChange('phy_exclude', e)"
                      :name="'phy_exclude'"
                      :id="'phy_exclude'"
                      :checked="
                        selectedAccountDetails.royalty_account.phy_exclude
                      "
                    />
                    <div class="checkmark"></div>
                  </div>
                  <div class="txtov">Exclude</div>
                </div>
              </div>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12>
              <div class="label_box txtov">Bundle DL</div>
              <div class="input_box_container">
                <div class="input_box_content">
                  <Dropdown
                    :showValidationIcons="false"
                    :id="'bundle_dl_mechanical_rate_id'"
                    class="m2"
                    :options="currentRatesTV"
                    :selected="
                      currentRatesTV.find(
                        (b) =>
                          b.value ==
                          contract_mechanical_info.bundle_dl_mechanical_rate_id
                      )
                    "
                    :placeholder="
                      $t('statutory Rate (leave Empty for Rate of Sale)')
                    "
                    deselect
                    box
                    @selectedChange="
                      (b) => onDropdownChange('bundle_dl_mechanical_rate_id', b)
                    "
                  ></Dropdown>
                </div>
                <div class="check_box_content">
                  <div class="dt-checkbox v2 s1">
                    <input
                      type="checkbox"
                      @click="(e) => onCheckboxChange('bundle_dl_exclude', e)"
                      :name="'bundle_dl_exclude'"
                      :id="'bundle_dl_exclude'"
                      :checked="
                        selectedAccountDetails.royalty_account.bundle_dl_exclude
                      "
                    />
                    <div class="checkmark"></div>
                  </div>
                  <div class="txtov">Exclude</div>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <div class="label_box txtov">Track DL</div>
              <div class="input_box_container">
                <div class="input_box_content">
                  <Dropdown
                    :showValidationIcons="false"
                    :id="'track_dl_mechanical_rate_id'"
                    class="m2"
                    :options="currentRatesTV"
                    :selected="
                      currentRatesTV.find(
                        (b) =>
                          b.value ==
                          contract_mechanical_info.track_dl_mechanical_rate_id
                      )
                    "
                    :placeholder="
                      $t('statutory Rate (leave Empty for Rate of Sale)')
                    "
                    deselect
                    box
                    @selectedChange="
                      (b) => onDropdownChange('track_dl_mechanical_rate_id', b)
                    "
                  ></Dropdown>
                </div>
                <div class="check_box_content">
                  <div class="dt-checkbox v2 s1">
                    <input
                      type="checkbox"
                      @click="(e) => onCheckboxChange('track_dl_exclude', e)"
                      :name="'track_dl_exclude'"
                      :id="'track_dl_exclude'"
                      :checked="
                        selectedAccountDetails.royalty_account.track_dl_exclude
                      "
                    />
                    <div class="checkmark"></div>
                  </div>
                  <div class="txtov">Exclude</div>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <!-- <TextField
            style="width: 84%; padding: 2px 0px"
            :id="'license_royalty_rate'"
            class="m1 input_box"
            v-bind="textFieldConfig"
            type="text"
            :value="contract_mechanical_info.license_royalty_rate"
            required
            disabled
            :showValidationIcons="false"
            :placeholder="$t('licencing')"
            @valuechanged="onTextFieldValueChange"
          /> -->
        </div>
      </div>
    </template>
    <div></div>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
      <button
      :disabled="!isFormValid"
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 s6"
        @click.stop="onOkClick"
      >
        Ok
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import { AccountsService } from "../../services/accounts.service";
import { accountsRoyaltyGetters } from "../../store/accounts/getters";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { accountsRoyaltyActions } from "../../store/accounts/actions";
import { createTV } from "../../../../models/text-value.model";
import { EventHooks } from "../../../../plugins/text-field";
import * as ActionTypes from "../../store/types";
export default {
  components: {
    Modal,
    InputField,
  },
  props: ["selectedAccountDetails"],
  data() {
    return {
      contract_mechanical_info: this.get_new_mechanical_contract_info(),
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnKeyup,
        isModel: true,
      },
      validationResult: {},
    };
  },
  mounted() {
    this.fetchMechanicalContractFormData();
  },
  mixins: [],

  computed: {
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
    believe_special() {
      return this.$store.getters.account.believe_special;
    },
    royalty_account_id: function () {
      return this.$route.params.royalty_account_id;
    },
    territoriesTV: function () {
      return createTV(
        this.contract_mechanical_info.territories,
        "label",
        "value"
      );
    },
    currentRatesTV: function () {
      return createTV(
        this.contract_mechanical_info.current_rates,
        "rate_name",
        "mechanical_rate_id"
      );
    },
  },
  methods: {
    ...mapActionObject(storeNS, accountsRoyaltyActions),
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    fetchMechanicalContractFormData: async function () {
      const result = await AccountsService.fetchMechanicalContractFormData({
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
        ...this.contract_mechanical_info,
      });
      this.contract_mechanical_info = {
        ...result.data,
        ...this.contract_mechanical_info,
      };
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onTextFieldValueChange: function (name, value) {
      this.contract_mechanical_info[name] = value;
    },

    onCopyContract: function () {
      this.onCancel();
      this.$emit("add_click", "copy_contract_form");
    },
    onHarryFoxContract: function () {
      this.onCancel();
      this.$emit("add_click", "harry_fox_contract_form");
    },
    onDropdownChange(name, value) {
      this.contract_mechanical_info[name] = value.value;
    },
    onOkClick: async function () {
      const res = await AccountsService.addNewMechanicalContract({
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
        ...this.contract_mechanical_info,
      });
      this.$emit("added", res.data.contracts);
    },
    get_new_mechanical_contract_info: function () {
      return {
        royalty_account_id:
          this.selectedAccountDetails?.account?.royalty_account_id,
        contract_name: "",
        territory_id: "",
        phy_mechanical_rate_id: "",
        phy_exclude: "",
        bundle_dl_mechanical_rate_id: "",
        bundle_dl_exclude: "",
        track_dl_mechanical_rate_id: "",
        track_dl_exclude: "",
        physical_royalty_rate: "",
        digital_royalty_rate: "",
        license_royalty_rate: "",
        fix_price: "",
        physical_base: "",
        digital_base: "",
        cost_split_percent: "",
      };
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-royalty_account-sidewindow-add_contract_form {
  .form-group .input_box_container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    .input_box_content {
      width: 100%;
      margin-right: 5px;
    }
    .check_box_content {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .txtov {
        padding-left: 5px;
      }
    }
  }
  .form-group .input_box {
    padding: 2px 0px;
  }
  .form-group .label_box {
    padding: 2px 0px;
    color: rgba(70, 70, 70, 0.77);
  }

  .copy_button {
    margin-top: 20px;
  }
}
</style>
